import React from 'react';
import clsx from 'clsx';

import './CircleCounter.scss';

function CircleCounter({ count, className }) {
  return (
    <div
      className={clsx(
        'circle-counter',
        count < 10 && 'circle-counter--rounded',
        !count && 'circle-counter--inactive',
        count && 'circle-counter--active',
        className,
        !count && className && `${className}--inactive`,
        count && className && `${className}--active`,
      )}>
      <span>{String(count)}</span>
    </div>
  );
}

export default CircleCounter;
